var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.495117,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6115 27.7999C13.07 27.7999 8.19812 21.9442 7.99512 12.2003H12.2737C12.4142 19.3521 15.5684 22.3815 18.0669 23.0061V12.2003H22.0958V18.3683C24.563 18.1029 27.1548 15.2921 28.0292 12.2003H32.058C31.3866 16.0104 28.5758 18.8212 26.5771 19.9767C28.5758 20.9136 31.7771 23.3652 32.9951 27.7999H28.5602C27.6077 24.833 25.2344 22.5376 22.0958 22.2253V27.7999H21.6115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.f34963ecbf2a7b30e8a7acc54431bcdf.svg";
export { ForwardRef as ReactComponent };